// extracted by mini-css-extract-plugin
module.exports = {"what":"What_what__3AOfJ","rewards":"What_rewards__2fWWl","button":"What_button__Us6I0","tiers":"What_tiers__9wCR-","top":"What_top__2utP1","breadcrumb":"What_breadcrumb__1SAgr"};